import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ArticleUsageVO } from '@article/model/vo/article.vo';

type ArticlesAdded = {
  type: string;
  articleId: number;
} & ({
  success: false;
} | {
  success: true;
  articleUsages: ArticleUsageVO[];
})

@Injectable({ providedIn: 'root' })
export class ArticleCreationService {
  private _articlesAdded$ = new Subject<ArticlesAdded>();

  public get articlesAdded$(): Observable<ArticlesAdded> {
    return this._articlesAdded$.asObservable();
  }

  public articlesAdded(type: string, articleId: number, articleUsages: ArticleUsageVO[]): void {
    this._articlesAdded$.next({type, articleId, success: true, articleUsages});
  }

  public articlesAddFailure(type: string, articleId: number): void {
    this._articlesAdded$.next({success: false, type, articleId: articleId});
  }
}
